import React, { useState } from 'react';
import CategoryPointsLostChart from './CategoryPointsLostChart';
import RequirementPointsChart from './RequirementPointsChart';

const ChartsCarousel = ({ categories }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const charts = [
    { component: CategoryPointsLostChart, id: 'points-lost' },
    { component: RequirementPointsChart, id: 'requirement-distribution' }
  ];

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex === 0 ? charts.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex === charts.length - 1 ? 0 : prevIndex + 1));
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const ActiveComponent = charts[activeIndex].component;

  return (
    <div className="relative w-full mb-6 p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800 overflow-visible">
      <div className="flex items-center justify-center relative">
        <button 
          className="absolute left-2.5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/80 dark:bg-gray-700/80 border border-gray-200 dark:border-gray-600 text-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all hover:bg-blue-600 hover:text-white hover:shadow-md"
          onClick={handlePrev}
          aria-label="Previous chart"
        >
          &#10094;
        </button>
        
        <div className="w-full overflow-visible">
          <ActiveComponent categories={categories} />
        </div>
        
        <button 
          className="absolute right-2.5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/80 dark:bg-gray-700/80 border border-gray-200 dark:border-gray-600 text-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all hover:bg-blue-600 hover:text-white hover:shadow-md"
          onClick={handleNext}
          aria-label="Next chart"
        >
          &#10095;
        </button>
      </div>
      
      <div className="flex justify-center mt-4 gap-2.5">
        {charts.map((_, index) => (
          <span
            key={index}
            className={`w-2.5 h-2.5 rounded-full cursor-pointer transition-colors ${
              index === activeIndex 
                ? 'bg-blue-600 scale-125' 
                : 'bg-gray-200 dark:bg-gray-600 hover:bg-blue-400'
            }`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to chart ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ChartsCarousel;
